import { render, staticRenderFns } from "./EPK.vue?vue&type=template&id=31ec12ec&scoped=true&"
import script from "./EPK.vue?vue&type=script&lang=js&"
export * from "./EPK.vue?vue&type=script&lang=js&"
import style0 from "./EPK.vue?vue&type=style&index=0&id=31ec12ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ec12ec",
  null
  
)

export default component.exports